import templateTicketTileActions from './ticketTileActions.template.html';

/* @ngInject */

export default ($timeout) => ({
  template: templateTicketTileActions,
  restrict: 'E',
  scope: {
    ticket: '<',
    tileColor: '<',
    tileColors: '<',
    tileActions: '<',
    onNoteAdd: '&',
    onJobAdd: '&',
    onLabelsSelect: '&',
    onPickColor: '&',
    onMoveToAnotherWorkflow: '&',
    onBccCopy: '&'
  },
  link(scope, element) {
    const self = scope;
    self.isMenuVisible = false;

    self.hasAction = (action) => _.indexOf(self.tileActions, action) > -1;

    self.noteAdd = ($event) => {
      self.onNoteAdd({ event: $event });
    };

    self.jobAdd = ($event) => {
      self.onJobAdd({ event: $event });
    };

    self.labelsSelect = ($event) => {
      self.onLabelsSelect({ event: $event });
    };

    self.moveToAnotherWorkflow = ($event) => {
      self.onMoveToAnotherWorkflow({ event: $event });
    };

    self.bccCopy = ($event) => {
      self.onBccCopy({ event: $event });
    };

    self.pickTileColor = (tileColor) => {
      self.tileColor = tileColor;
      if (self.onPickColor) {
        self.onPickColor({ tileColor });
      }
      self.isMenuVisible = false;
    };

    self.getNameOfTileColor = (colorName) =>
      colorName.replace(/[^a-zA-Z]/g, '').capitalizeFirstLetter();

    self.showMenu = ($event) => {
      $event.stopPropagation();
      $event.preventDefault();
      self.isMenuVisible = true;
      $timeout(() => {
        element.find('md-menu').find('button').triggerHandler('click');
      });
    };
  }
});
